module.exports = __webpack_public_path__ + "res/ic_square_check.d131bf80f8e7118f2a5c0b630e7b586c.png";